import { useState, useRef } from "react";
import { PageTitle } from "../../components";
import { Button, Form, Input, message, Upload } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import "quill/dist/quill.snow.css";
import { CURRENT_CLUB_ID } from "../../_helpers/constants";
import { newsApi } from "../../_helpers/apiService";

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

function AddNews() {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const [value, setValue] = useState("");
  const [newsImage, setNewsImage] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [imageUploading, setImageUploading] = useState(false);
  const [newsImageUrl, setNewsImageUrl] = useState<string | null>(null);
  const [newsImageName, setNewsImageName] = useState<string | null>(null);
  const userData = useSelector((state: any) => state.authentication.userData);

  const editorRef = useRef(null);

  const onFinish = () => {
    // @ts-ignore
    const content =
      // @ts-ignore
      editorRef.current.getEditor().getLength() > 1
        ? // @ts-ignore
          editorRef.current.getEditor().getText().trim().length
        : 0;

    if (content <= 0) {
      setShowError(true);
      return;
    } else {
      setShowError(false);
    }
    form
      .validateFields()
      .then(async (values) => {
        setLoading(true);
        try {
          await newsApi.create({
            title: values.name,
            description: values.description,
            content: value,
            author_id: userData?.id || 0,
            author_name: `${userData?.first_name || ''} ${userData?.last_name || ''}`.trim() || 'Unknown',
            author_image_url: userData?.profile_image_url || undefined,
            club_id: CURRENT_CLUB_ID,
            image_url: newsImageUrl || undefined,
            image_name: newsImageName || undefined,
          });

          setLoading(false);
          form.resetFields();
          setNewsImage(null);
          setNewsImageUrl(null);
          setNewsImageName(null);
          setValue("");
          message.success("Мэдээ амжилттай нэмэгдлээ");
          navigate("/news");
        } catch (error: any) {
          message.error("Мэдээ нэмэхэд алдаа гарлаа");
          setLoading(false);
        }
      })
      .catch((info) => {
        setLoading(false);
      });
  };

  const uploadButton = (
    <div>
      {imageUploading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Сонгох</div>
    </div>
  );

  const customRequest = async ({ file, onSuccess, onError }: any) => {
    setImageUploading(true);
    try {
      const response = await newsApi.uploadImage(file);
      setNewsImageUrl(response.data.image_url);
      setNewsImageName(response.data.image_name);
      setNewsImage(file);
      message.success("Зураг амжилттай байршуулагдлаа");
      onSuccess();
    } catch (error) {
      message.error("Зураг байршуулахад алдаа гарлаа");
      onError(error);
    } finally {
      setImageUploading(false);
    }
  };

  return (
    <>
      <PageTitle
        loading={loading}
        title={`Мэдээ нэмэх`}
        right={null}
        breadcrumbItems={[
          { link: "/news", title: "Мэдээ" },
          { title: "Мэдээ нэмэх" },
        ]}
      />
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <Form
                    {...formItemLayout}
                    form={form}
                    onFinish={() => onFinish()}
                  >
                    <Form.Item
                      label="Нэр"
                      name="name"
                      rules={[{ required: true, message: "Нэр оруулна уу!" }]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="Товч"
                      name="description"
                      rules={[
                        {
                          required: true,
                          message: "Товч мэдээлэл оруулна уу!",
                        },
                      ]}
                    >
                      <Input.TextArea />
                    </Form.Item>

                    <Form.Item label="Мэдээний зураг" valuePropName="newsImage">
                      <Upload
                        beforeUpload={(file) => {
                          const isPNG =
                            file.type === "image/png" ||
                            file.type === "image/jpg" ||
                            file.type === "image/jpeg";
                          if (!isPNG) {
                            message.error(`Зургийн файл буруу байна`);
                          }
                          return isPNG || Upload.LIST_IGNORE;
                        }}
                        customRequest={customRequest}
                        fileList={newsImage ? [newsImage] : []}
                        listType="picture-card"
                      >
                        {uploadButton}
                      </Upload>
                    </Form.Item>

                    <Form.Item
                      label="Мэдээлэл"
                      style={{ height: 200, marginBottom: 100 }}
                    >
                      <div style={{ minHeight: 200 }}>
                        <ReactQuill
                          ref={editorRef}
                          theme="snow"
                          value={value}
                          onChange={setValue}
                          style={{
                            maxHeight: 150,
                          }}
                        />
                      </div>
                      {showError && (
                        <span style={{ color: "red" }}>
                          Мэдээлэл оруулна уу
                        </span>
                      )}
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                      >
                        Нийтлэх
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AddNews;
